__turbopack_context__.v({
  "loginModal": "modalLogin-module-scss-module__tH6uza__loginModal",
  "modalLogin": "modalLogin-module-scss-module__tH6uza__modalLogin",
  "wrapper": "modalLogin-module-scss-module__tH6uza__wrapper",
});
